import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useContextLoader } from 'admin/lib/Records'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import { RecordEdit } from './RecordEdit'

export function RecordEditWrapper() {
  const { accountId, projectId, moduleName } = useParams()
  const contextLoader = useContextLoader(accountId, projectId, moduleName)

  useEffect(() => {
    const checkVisibilityChange = () => {
      if (document.hidden) {
        performance.mark('record-edit-page-status', {
          detail: { context: 'Browser tab is now inactive (hidden)' }
        })
      } else {
        performance.mark('record-edit-page-status', {
          detail: { context: 'Browser tab is now active (visible)' }
        })
      }
    }

    // Initial check when the component mounts
    if (document.hidden) {
      performance.mark('record-edit-page-load', {
        detail: { context: 'Page loaded in a hidden tab' }
      })
    } else {
      performance.mark('record-edit-page-load', {
        detail: { context: 'Page loaded in an active tab' }
      })
    }

    window.addEventListener('visibilitychange', checkVisibilityChange)
    return () => {
      window.removeEventListener('visibilitychange', checkVisibilityChange)
    }
  }, [])

  if (contextLoader.loaded) {
    return <RecordEdit contextLoader={contextLoader}></RecordEdit>
  }

  return (
    <div
      style={{
        width: '90vw',
        height: '400px',
        margin: '5rem auto 0',
        textAlign: 'center'
      }}
    >
      <ScreenSpin />
    </div>
  )
}
